const activeModals = new Map();

export const Modal = {
  show(selector, options = {}) {
    const modal = document.querySelector(selector);
    if (!modal) {
      return;
    }

    // Only block if modal is actually active in DOM
    if (activeModals.has(selector) && modal.classList.contains("is-active")) {
      return;
    }

    // Clean up stale entry if modal isn't actually active
    if (activeModals.has(selector) && !modal.classList.contains("is-active")) {
      activeModals.delete(selector);
    }

    const keydownListener = (ev) => {
      if (ev.key == "Escape") {
        ev.preventDefault();
        dismiss();
      }
    };

    const dismiss = (element) => {
      const currentModal = document.querySelector(selector);
      if (currentModal) {
        currentModal.classList.remove("is-active");
      }
      document.removeEventListener("keydown", keydownListener);
      activeModals.delete(selector);
      if (options?.onDismiss) {
        options.onDismiss(element);
      }
      modal.dispatchEvent(
        new CustomEvent("modal:close", {
          bubbles: true,
          detail: { modal: modal },
        })
      );
    };

    document.addEventListener("keydown", keydownListener);
    activeModals.set(selector, { dismiss, keydownListener });

    modal.querySelectorAll("[data-closes]").forEach((element) => {
      element.addEventListener("click", () => {
        // Let the form submit before hiding the modal — without this,
        // downloads (such as PNGs) may auto-open.
        if (element.type === "submit" && element.form) {
          setTimeout(() => dismiss(element), 0);
        } else {
          dismiss(element);
        }
      });
    });

    modal.classList.add("is-active");

    modal.dispatchEvent(
      new CustomEvent("modal:open", {
        bubbles: true,
        detail: { modal: modal },
      })
    );
  },

  hide(selector) {
    const modal = document.querySelector(selector);
    if (!modal) {
      return;
    }

    const modalData = activeModals.get(selector);
    if (modalData) {
      modalData.dismiss();
    } else {
      modal.classList.remove("is-active");
    }
  },
};

window.Modal = Modal; // to ensure it works in .js.erb files and i.e. onclick="Modal.show(&#39;#avery-modal&#39;);"
